/**
 * Shop listing analytics `target` segments for `useWithAnalytics` / `getEventName`.
 * Import action strings from `@stadium/services/analytics/constants/default` where they match generic names
 * (`applied`, `removed`, `changed`, etc.).
 */

export const ANALYTICS_TARGET_FILTER = "filter";
export const ANALYTICS_TARGET_SORT = "sort";
export const ANALYTICS_TARGET_LISTING = "listing";
export const ANALYTICS_TARGET_FILTER_SECTION = "filter_section";
export const ANALYTICS_TARGET_PAGINATION = "pagination";

/** Collapse control — no generic equivalent in analytics default constants. */
export const ANALYTICS_ACTION_SECTION_COLLAPSED = "collapsed";
